import { Signal, computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { FeatureFlagService } from '../services/feature-flag.service';

/**
 * Lets the Cold Calls screens open only while the `ColdCallLiveAssistant` flag is on, the staged rollout the
 * API enforces as well (A-06). Waits for `flagsLoaded` so a deep link or a hard refresh is not
 * redirected before PostHog has answered. The module itself is checked by `capabilityGuard`.
 */
export const coldCallsGuard: CanActivateFn = () => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);

  return toObservable(featureFlagService.flagsLoaded).pipe(
    filter(Boolean),
    take(1),
    map(() => (featureFlagService.getFlagVariant('ColdCallLiveAssistant') ? true : router.createUrlTree(['/main/dashboard'])))
  );
};

/**
 * Whether Cold Calls is offered: the `ColdCallLiveAssistant` flag and the `coldCallAssistant` module,
 * the same pair the routes check. Also hides what only Cold Calls uses, such as the Openers document.
 * Call it in an injection context.
 */
export function coldCallsAvailable(): Signal<boolean> {
  const featureFlagService = inject(FeatureFlagService);
  const authService = inject(AuthService);
  return computed(() => !!featureFlagService.getFlagVariant('ColdCallLiveAssistant') && authService.hasCapability('coldCallAssistant'));
}
